import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f4f5dda&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3f4f5dda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f5dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4f5dda')) {
      api.createRecord('3f4f5dda', component.options)
    } else {
      api.reload('3f4f5dda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f4f5dda&scoped=true", function () {
      api.rerender('3f4f5dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/functionModule/role/index.vue"
export default component.exports